import { createContext, useContext, useState, useEffect } from "react";
import api from "@/lib/api";
import { BACKEND_URL } from "@/config";

const SiteSettingsContext = createContext();

export const useSiteSettings = () => useContext(SiteSettingsContext);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await api.get('/SiteSetting');
        if (res.success && res.data && res.data.length > 0) {
          setSettings(res.data[0]);
        }
      } catch (err) {
        console.error("Failed to load site settings", err);
      }
    };
    fetchSettings();
  }, []);

  useEffect(() => {
    if (settings?.faviconUrl) {
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      
      const url = settings.faviconUrl;
      link.href = url.startsWith('http') ? url : `${BACKEND_URL}${url.startsWith('/') ? '' : '/'}${url}`;
    }
  }, [settings]);

  return (
    <SiteSettingsContext.Provider value={{ settings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};
